import { CurrentUser } from 'tm3-core/api.dtos';

import { MobxAutoDecorateWithKeyObj } from '../decorate';

export {};

declare module 'tm3-core/api.dtos' {
  namespace CurrentUser {
    export function instance(user: CurrentUser): CurrentUser;
    export function isInstance(x: any): x is CurrentUser;
  }
}

CurrentUser.isInstance = (x) => {
  return x instanceof CurrentUser;
};

CurrentUser.instance = (user) => {
  return !CurrentUser.isInstance(user) ? new CurrentUser(user) : user;
};

MobxAutoDecorateWithKeyObj(CurrentUser, {
  authProvider: true,
  avatar: true,
  bearerToken: true,
  clientId: true,
  cloudRxClinicCode: true,
  cloudRxUserCode: true,
  customer: true,
  departments: true,
  displayName: true,
  email: true,
  hasPassKey: true,
  hasTrialExpired: true,
  id: true,
  isAuthenticated: true,
  isEvaluating: true,
  lastName: true,
  location: true,
  meta: true,
  mobileNumber: true,
  name: true,
  needsVerified: true,
  permissions: true,
  pharmaciergeIntegrationCode: true,
  pinHash: true,
  practitioner: true,
  practitionerId: true,
  profileUrl: true,
  referrerUrl: true,
  refreshToken: true,
  refreshTokenExpiry: true,
  responseStatus: true,
  roleId: true,
  roleName: true,
  roles: true,
  sessionId: true,
  settings: true,
  signature: true,
  signatureRxIntegrationCode: true,
  tM2UserName: true,
  tours: true,
  twoFactorAllowSms: true,
  twoFactorAuthenticated: true,
  twoFactorRequired: true,
  twoFactorSetup: true,
  userGlobalGuid: true,
  userId: true,
  userName: true,
  userPermissionId: true,
  userType: true
});
